var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18.0 18.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "off_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "off_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.83,2.17 C16.77,3.82 18,6.26 18,9 C18,13.97 13.97,18 9,18 C4.03,18 0,13.97 0,9 C0,6.26 1.23,3.82 3.17,2.17 L4.58,3.58 C3.01,4.86 2,6.81 2,9 C2,12.87 5.13,16 9,16 C12.87,16 16,12.87 16,9 C16,6.81 14.99,4.86 13.41,3.59 Z M10,0 L10,10 L8,10 L8,0 L10,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-231.0 -667.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#off_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.9999999999986 664.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0 3.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#off_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 18,0 18,18 0,18 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power_off.417545acbf58b8ae8bd4b9bd960f58e2.svg";
export { ForwardRef as ReactComponent };